"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const quote_widget_json_1 = __importDefault(require("~/locales/en/quote-widget.json"));
const actions_1 = require("~/store/actions");
const api_1 = require("~/store/api");
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const consts_1 = require("../account/consts");
const actions_2 = require("./actions");
const consts_2 = require("./consts");
const getProjectId = (state) => { var _a; return (_a = state.project.currentProject) === null || _a === void 0 ? void 0 : _a.id; };
const getRevisionNumber = (state) => { var _a, _b; return (_b = (_a = state.bom) === null || _a === void 0 ? void 0 : _a.bom) === null || _b === void 0 ? void 0 : _b.revisionNumber; };
const getUserId = (state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id; };
const getUsertype = (state) => { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userType) === null || _c === void 0 ? void 0 : _c.name; };
const getCurrentProject = (state) => state.project.currentProject;
function* submit({ payload }) {
    try {
        const projectId = yield (0, effects_1.select)(getProjectId);
        const revisionNumber = yield (0, effects_1.select)(getRevisionNumber);
        const screenShots = yield (0, effects_1.call)(utils_1.getScreenShots);
        const userId = yield (0, effects_1.select)(getUserId);
        const currentProject = yield (0, effects_1.select)(getCurrentProject);
        const currentUserType = yield (0, effects_1.select)(getUsertype);
        const response = yield (0, effects_1.call)(api_1.submitQuote, Object.assign(Object.assign({}, payload), { screenShots }));
        if ('error' in response) {
            yield (0, effects_1.put)((0, actions_2.submitQuoteError)(response));
        }
        else {
            const isProjectShared = (currentProject === null || currentProject === void 0 ? void 0 : currentProject.status) !== types_1.PROJECT_STATUS.IN_PROGRESS;
            const quoteMessages = quote_widget_json_1.default['success-messages'];
            let message = quoteMessages.success;
            if (currentUserType === consts_1.UserRoles.distributor) {
                if (payload.sharedWithAdmins) {
                    message = isProjectShared
                        ? quoteMessages['success-distributor-admin-revision']
                        : quoteMessages['success-distributor-admin'];
                }
                else {
                    message = isProjectShared
                        ? quoteMessages['success-distributor-customer-revision']
                        : quoteMessages['success-distributor-customer'];
                }
            }
            else if (isProjectShared) {
                message = quoteMessages['success-revision'];
            }
            yield (0, effects_1.put)((0, actions_1.setBomSubmitDisabled)(true));
            yield (0, effects_1.call)(events_1.showNotification, {
                message,
                type: 'success',
            });
            yield (0, effects_1.put)((0, actions_1.updateRevisionAction)({
                revisionNumber: revisionNumber.split('-')[1],
                projectId,
                userId,
            }));
            yield (0, effects_1.put)((0, actions_1.toggleQuote)(false));
            yield (0, effects_1.put)((0, actions_1.resetQuote)());
            yield (0, effects_1.put)((0, actions_2.setEnabled)());
            const submittedProject = yield (0, effects_1.call)(api_1.getFullProject, projectId);
            yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(submittedProject));
        }
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* rootSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeLatest)(consts_2.SUBMIT_QUOTE, submit)]);
}
exports.default = rootSaga;
